export const EventEmitter = {
  events: {},
  dispatch(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach((callback) => callback(data));
  },
  subscribe(event, callback) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(callback);
  },
  unsubscribe(event) {
    if (!this.events[event]) return;
    delete this.events[event];
  },
};

export const EVENT_KEY = {
  TIME_UPDATE: "TIME_UPDATE",
  TIME_SEEK: "TIME_SEEK",
  PAUSE_VIDEO: "PAUSE_VIDEO",
  MUTE_VIDEO: "MUTE_VIDEO",
  PLAYBACK_RATE: "PLAYBACK_RATE",
  RESTART_VIDEO: "RESTART_VIDEO",
  TIME_UPDATE_WEBCAMS: "TIME_UPDATE_WEBCAMS",
  PAUSE_WEBCAMS: "PAUSE_WEBCAMS",
  TIME_SEEK_WEBCAMS: "TIME_SEEK_WEBCAMS",
  PLAYBACK_RATE_WEBCAMS: "PLAYBACK_RATE_WEBCAMS",
};
